import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import Data from '../../../../components/Display/Data';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import Tag from '../../../../components/Display/Tag';
import { CONSTANT } from '../../../../utils/constants';
import ImageItem from '../../common/image/ImageItem';
import DocumentItem from '../../common/document/DocumentItem';

function ProjectDetail({
  project,
  handleUpdateProject,
  handleDelete,
  handleUpdateFile,
  handleDeleteFile,
  handleCreateFile,
  handleUpdateImage,
  handleUpdateImages
}) {
  const updateProjectActions = [
    {
      onClick: handleUpdateProject,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const newFileActions = [
    {
      onClick: handleCreateFile,
      label: 'Ajouter un fichier',
      icon: 'pi-plus'
    }
  ];

  const changeImageActions = [
    {
      onClick: handleUpdateImage,
      label: "Modifier l'image",
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (project) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce Projet ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(project)
    });
  };

  const confirmDocumentDeletion = (document) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteFile(document)
    });
  };

  const updateImagesActions = [
    {
      onClick: handleUpdateImages,
      label: 'Modifier les images',
      icon: 'pi-pencil'
    }
  ];

  return (
    <div className="h-full w-full flex-col flex gap-5">
      <Section label="Informations Générales" actions={updateProjectActions}>
        <div className="flex flex-row gap-5">
          <Tag
            tag={CONSTANT.prna.statusTypes.find((s) => s.value === project.state)}
            rounded
            className="w-fit"
          />
          {project.is_highlight && (
            <Tag
              tag={{
                label: 'Projet mis en avant',
                icon: 'star',
                bgColor: 'bg-purple-800'
              }}
              rounded
            />
          )}
        </div>

        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={project.title} large />
          <Data key="place_name" label={'Localisation'} value={project.place_name} large />
          <Data key="build_master" label={"Maître d'ouvrage"} value={project.build_master} large />
          <Data key="year" label={'Année'} value={project.year} />
        </div>
        <div className="flex flex-wrap gap-5">
          <Data key="surface" label={'Surface'} value={project.surface} suffix={'m²'} />
          <Data key="cost" label={'Montant des travaux'} value={project.cost} suffix={'€'} />
          <Data
            key="conception_team"
            label={'Équipe conception'}
            value={project.conception_team}
            large
          />
          <Data
            key="construction_team"
            label={'Équipe travaux'}
            value={project.construction_team}
            large
          />
          <Data
            key="certifications"
            label={'Certifications'}
            value={project.certifications}
            large
          />
          <Data key="photograph" label={'Photographie'} value={project.photograph} large />
          <Data key="perspective" label={'Perspective'} value={project.perspective} large />
          <Data key="status" label={'Statut'} value={project.status} large />
          <Data key="program" label={'Programme'} value={project.program} large />
        </div>
        <div className="flex flex-row gap-5">
          <MultiLineData
            key="description"
            label={'Description'}
            value={project.description}
            large
            asHtml
          />
        </div>
      </Section>

      <Section label="Image Principale" actions={changeImageActions}>
        {!project?.main_image ? (
          <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
        ) : (
          <ImageItem image={project.main_image} className={'w-[400px]'} />
        )}
      </Section>
      <Section label="Dossier de presse" actions={!project?.file && newFileActions}>
        {!project?.file ? (
          <span className="italic text-slate-400 font-light">Aucun fichier à afficher</span>
        ) : (
          <DocumentItem
            document={project.file}
            onDelete={() => confirmDocumentDeletion(project.file)}
            onUpdate={() => handleUpdateFile(project.file)}
          />
        )}
      </Section>

      <Section label="Images secondaires" actions={updateImagesActions}>
        <div className={`flex flex-wrap gap-3`}>
          {!project?.images?.length ? (
            <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
          ) : (
            project?.images?.map((img, index) => (
              <ImageItem
                key={index}
                image={img}
                alt={`Photo de ${project.title} n°${index}`}
                className="h-60"
              />
            ))
          )}
        </div>
      </Section>

      <Section label="Autres actions">
        <div>
          <Button
            key={'delete'}
            label={'Supprimer le projet'}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(project)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default ProjectDetail;
